import { cn as e } from "../shared/utils.js";
import { Accordion as t } from "@base-ui/react/accordion";
import { ChevronDownIcon as n } from "@systemeio/icons";
import { forwardRef as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/accordion/accordion.tsx
var o = r((e, n) => /* @__PURE__ */ i(t.Root, {
	ref: n,
	...e
})), s = r(({ className: n, ...r }, a) => /* @__PURE__ */ i(t.Item, {
	ref: a,
	className: e("border-border-100 bg-bg-primary overflow-hidden rounded-xl border", "transition-base transition-shadow", "has-[button:focus-visible]:focus-ring-primary", n),
	...r
})), c = r(({ className: n, ...r }, a) => /* @__PURE__ */ i(t.Header, {
	ref: a,
	className: e("m-0", n),
	...r
})), l = r(({ className: n, ...r }, a) => /* @__PURE__ */ i(t.Trigger, {
	ref: a,
	className: e("text-text-primary flex w-full items-center gap-2 p-5 text-left text-base font-semibold outline-none", n),
	...r
})), u = r(({ className: n, ...r }, a) => /* @__PURE__ */ i(t.Panel, {
	ref: a,
	className: e("text-text-secondary h-(--accordion-panel-height) overflow-hidden text-base", "transition-base transition-[height,opacity]", "data-ending-style:h-0 data-ending-style:opacity-0 data-starting-style:h-0 data-starting-style:opacity-0", n),
	...r
})), d = r(({ className: t, ...n }, r) => /* @__PURE__ */ i("div", {
	ref: r,
	className: e("px-5 pb-5", t),
	...n
}));
o.displayName = t.Root.displayName ?? "AccordionRoot", s.displayName = t.Item.displayName, c.displayName = t.Header.displayName, l.displayName = t.Trigger.displayName, u.displayName = t.Panel.displayName, d.displayName = "AccordionContent";
var f = Object.assign(function({ children: t, label: r, contentProps: f, headerProps: p, itemProps: m, panelProps: h, triggerProps: g, ..._ }) {
	return /* @__PURE__ */ i(o, {
		..._,
		children: /* @__PURE__ */ a(s, {
			...m,
			children: [/* @__PURE__ */ i(c, {
				...p,
				children: /* @__PURE__ */ a(l, {
					...g,
					className: e("group", g?.className),
					children: [/* @__PURE__ */ i("span", {
						className: "min-w-0 flex-1 truncate",
						children: r
					}), /* @__PURE__ */ i(n, { className: "transition-base size-5 shrink-0 text-current transition-transform group-data-panel-open:rotate-180" })]
				})
			}), /* @__PURE__ */ i(u, {
				...h,
				children: /* @__PURE__ */ i(d, {
					...f,
					children: t
				})
			})]
		})
	});
}, {
	Root: o,
	Item: s,
	Header: c,
	Trigger: l,
	Panel: u,
	Content: d
});
//#endregion
export { f as Accordion };
